import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckboxOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "checkbox-bg",
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 2,
			ry: 2,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "checkbox-tick",
			d: "M18 8L10 16L6 12",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgIconCheckboxOutlined);
export { ForwardRef as ReactComponent };
